import { createAsyncThunk } from "@reduxjs/toolkit";
import { RestS } from "../../rest/rest-service";
import { notificationEventTypes, NotificationState } from "./notificationSlice";

export const clearAsyncNotification = createAsyncThunk(
  "chatSlice/clearNotifications",
  async (
    { notificationId, isUnread }: { notificationId: number; isUnread: boolean },
    { getState, rejectWithValue, dispatch }
  ) => {
    try {
      const notificationState = getState()[
        "notificationState"
      ] as NotificationState;

      const updatedNotification = await RestS.updateNotificationStatusById(
        notificationId,
        5
      );

      const matchedKey = Object.keys(notificationEventTypes).reduce(
        (prev, curVal) => {
          if (prev == null) {
            if (
              notificationEventTypes[curVal].includes(
                updatedNotification.notificationEvent
              )
            ) {
              prev = curVal;
            }
          }
          return prev;
        },
        null
      );
      //
      let allNotifications = [...notificationState.all.notifications].filter(
        (item) => item.id !== notificationId
      );
      let allNotificationUnreadCount = isUnread
        ? notificationState.all.unreadCount - 1
        : notificationState.all.unreadCount;
      if (matchedKey !== null) {
        let matchedKeyUnreadCount = isUnread
          ? notificationState[matchedKey].unreadCount - 1
          : notificationState[matchedKey].unreadCount;
        let matchedKeyNotifications = [
          ...notificationState[matchedKey].notifications,
        ].filter((item) => item.id !== notificationId);
        return {
          allNotifications,
          allNotificationUnreadCount,
          matchedKeyUnreadCount,
          matchedKeyNotifications,
          matchedKey,
        };
      }
    } catch (error) {
      //
    }
  }
);
